import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { TabLink, TabLinks } from '@change-corgi/design-system-legacy/components/navigation';

type NavigationTabsProps = {
	selected?: 'about' | 'impact' | 'careers' | 'team';
	isSunriseEnabled?: boolean;
};

export function NavigationTabs({ selected, isSunriseEnabled }: NavigationTabsProps): JSX.Element | null {
	return (
		<TabLinks
			selected={selected || ''}
			sx={{
				...(isSunriseEnabled && {
					li: {
						fontWeight: 400,
						color: 'sunrise.semantic.typography.weak',
						// eslint-disable-next-line @typescript-eslint/naming-convention
						'&:has([data-active-link="true"])': {
							fontWeight: 700,
							color: 'sunrise.semantic.typography.interactive.default',
							borderColor: 'sunrise.semantic.stroke.selected',
						},
						// eslint-disable-next-line @typescript-eslint/naming-convention
						'&:has(a:focus), &:has(a:active)': {
							fontWeight: 700,
							color: 'sunrise.semantic.typography.interactive.default',
							borderColor: 'sunrise.semantic.stroke.selected',
						},

						// eslint-disable-next-line @typescript-eslint/naming-convention
						':hover': {
							color: 'sunrise.semantic.typography.interactive.default',
							borderColor: 'sunrise.semantic.stroke.selected',
							cursor: 'pointer',
							backgroundColor: 'sunrise.semantic.fill.hover',
						},
					},
				}),
			}}
		>
			<TabLink name="about" to="/about" data-active-link={selected === 'about'}>
				<Translate value="fe.components.brand_pages_navbar.about" />
			</TabLink>
			<TabLink name="impact" to="/impact" data-active-link={selected === 'impact'}>
				<Translate value="fe.components.brand_pages_navbar.impact" />
			</TabLink>
			<TabLink name="careers" to="/careers" data-active-link={selected === 'careers'}>
				<Translate value="fe.components.brand_pages_navbar.careers" />
			</TabLink>
			<TabLink name="team" to="/about/team" data-active-link={selected === 'team'}>
				<Translate value="fe.components.brand_pages_navbar.team" />
			</TabLink>
		</TabLinks>
	);
}
